import { render, staticRenderFns } from "./TabProposalSig.vue?vue&type=template&id=f8190990&scoped=true&"
import script from "./TabProposalSig.vue?vue&type=script&lang=js&"
export * from "./TabProposalSig.vue?vue&type=script&lang=js&"
import style0 from "./TabProposalSig.vue?vue&type=style&index=0&id=f8190990&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8190990",
  null
  
)

export default component.exports